export default __webpack_public_path__ + "img/fJUastgk.7f01cc02.svg";